import React from 'react';
import styled from 'styled-components';
import tokens from '../../../../../common/styles/design-tokens';

const SparklesIcon = ({ color, size, className }) => {
    const iconColor = color || tokens.colors.cyan;
    const iconSize = size || '1.2em';

    return (
        <StyledSvg
            viewBox="0 0 24 24"
            fill="currentColor"
            width={iconSize}
            height={iconSize}
            className={className}
            color={iconColor}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9.75 12L12 3.75L14.25 12L22.5 14.25L14.25 16.5L12 24.75L9.75 16.5L1.5 14.25L9.75 12Z" opacity="0.9" />
            <path d="M19.5 9L21 2.25L22.5 9L29.25 10.5L22.5 12L21 18.75L19.5 12L12.75 10.5L19.5 9Z" transform="scale(0.6) translate(10, -10)" opacity="0.7" />
            <path d="M4.5 9L6 2.25L7.5 9L14.25 10.5L7.5 12L6 18.75L4.5 12L-2.25 10.5L4.5 9Z" transform="scale(0.5) translate(10, 20)" opacity="0.7" />
        </StyledSvg>
    );
};

export default SparklesIcon;

// --- Styles ---
const StyledSvg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  color: ${props => props.color};
  
  @keyframes pulse {
    0% { opacity: 0.7; transform: scale(0.95); }
    50% { opacity: 1; transform: scale(1.05); }
    100% { opacity: 0.7; transform: scale(0.95); }
  }
`;